import { Component } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

interface RequiredDocument {
  name: string;
  requirement: string;
}

@Component({
    selector: "app-valid-help-link-dialog",
    templateUrl: "./valid-help-link-dialog.component.html",
    styleUrls: ["./valid-help-link-dialog.component.scss"],
    standalone: false
})
export class ValidHelpLinkDialogComponent {
  proofOfAddressColumns: string[] = ["document", "requirements"];
  proofOfAddressDocuments: RequiredDocument[] = [
    {
      name: "Financial Statement from a recognised lender (e.g. mortgage statement, pension provider, provident fund or endowment)",
      requirement: "Dated within 3 months",
    },
    {
      name: "Government issued statement (e.g. tax record, eligibility or employment history)",
      requirement: "Dated within 3 months",
    },
    {
      name: "Utility services bill (e.g. Gas or Electricity)",
      requirement: "Dated within 3 months",
    },
    {
      name: "Valid driving license",
      requirement: "If not used as proof of ID",
    },
  ];

  constructor(private readonly dialog: MatDialog) {}

  openDialog(): void {
    this.dialog.open(ValidHelpLinkDialogComponent, {
      maxHeight: "90vh",
      width: "80vw",
      data: {},
    });
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }
}
